import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { closed: Boolean }
  connect() {
    const product = this.element.closest("[data-marketplace-product]")
    product?.querySelectorAll("[data-marketplace-contact]").forEach(button => { button.disabled = this.closedValue })
    const chat = this.element.closest('[data-controller~="chat-room"]')
    if (chat) {
      chat.dataset.marketplaceClosed = String(this.closedValue)
      chat.querySelectorAll("[data-marketplace-composer]").forEach(fieldset => { fieldset.disabled = this.closedValue })
    }
  }
}
